/*
 * Uses jquery datepicker
 */
import * as React from "react"
import * as $ from "jquery"
import {Button} from "./button"

export interface DatePickerProps extends JQueryUI.DatepickerOptions {
	onChange: (text: string, date: Date) => void
	date?: Date
	readonly: boolean
	invalid: boolean
	disabled?: boolean
	hasClearButton?: () => void
}

export class DatePicker extends React.Component<DatePickerProps, {}> {
	inputElement: HTMLInputElement|null = null
	
	_destroyDatePicker() {
		if (this.inputElement) {
			$(this.inputElement).datepicker('destroy')
		}
	}

	_initDatePicker() {
		const _self = this
		const element = _self.inputElement
		if (element) {
			const options = {
				duration: 0,
				changeMonth: true,
				changeYear: true,
				showOn: 'both',
				yearRange: '1900:c+50',
				buttonImageOnly: true,
				buttonText: 'Select Date',
				dateFormat: 'dd/mm/yy',
				onClose: (text: string, inst: any) => {
					if (_self.props.onChange) {
						_self.props.onChange(text, $(element).datepicker('getDate'))
					}
				}
			}

			const newProps = Object.assign(options, this.props)

			$(element).datepicker(newProps);

			if (this.props.date !== undefined) {
				$(element).datepicker('setDate', this.props.date)
			}
		}
	}

	componentDidMount() {
		this._initDatePicker();
	}

	componentWillReceiveProps(props:DatePickerProps) {
		const _self = this
		const element = _self.inputElement
		if (element) {
			const $element = $(element)
			$element.datepicker(props.disabled ? 'disable' : 'enable')

			if(props.date === undefined || props.date === null) {
				$element.datepicker('setDate', null)
			}
		}
	}


	componentWillUnmount() {
		this._destroyDatePicker();
	}

	render() {
		return <span>
			<input
				type="text"
				ref={(inputElement) => { this.inputElement= inputElement }}
				style={this.props.invalid ? {border: "solid red 2px"} : undefined}
				disabled={this.props.disabled}
				readOnly={this.props.readonly}
				// {...this.props}
			/>
			{this.props.hasClearButton && <Button onClick={()=>{
				if(this.props.hasClearButton) {
					this.props.hasClearButton()
				}
			}}>Clear</Button>}
		</span>
	}
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/datePicker.tsx